import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxPermissionsModule } from "ngx-permissions";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { PipesModule } from "../../pipes/pipes.module";
import { MaterialModule } from "../../components/material/material.module";
import { ContadorService } from "../../providers/contador.service";
import { ContadorComponent } from "./contador/contador.component";
import { EditarContadorDialog } from "./editar-contador/editar-contador-dialog/editar-contador-dialog.component";
import { EditarContadorComponent } from "./editar-contador/editar-contador.component";

@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        ReactiveFormsModule,
        FormsModule,
        PipesModule,
        MaterialModule,
    ],
    declarations: [
        ContadorComponent,
        EditarContadorComponent,
        EditarContadorDialog,
    ],
    providers: [
        ContadorService,
    ],
    entryComponents: [
        EditarContadorDialog,
    ],
    exports: [
        EditarContadorComponent,
    ]
})
export class ContadorModule { }